// Informe independiente: no modifica registros ni aplica las simulaciones del PDF original.
export interface DatosDetalle {
  mes: string;
  trabajador: any;
  empresa: any;
  picajes: any[];
  resumen: any[];
  calculo?: any[];
  turnos: any[];
  fiestas: any[];
  ausencias: any[];
}

export function dos(n: number): string { return ('0' + n).slice(-2); }
export function fechaDetalle(t: number): string {
  const d = new Date(t);
  return d.getUTCFullYear() + '-' + dos(d.getUTCMonth() + 1) + '-' + dos(d.getUTCDate());
}
export function minutosTexto(n: number, saldo: boolean = false): string {
  return (n < 0 ? '-' : (saldo && n > 0 ? '+' : '')) +
    dosHoras(Math.floor(Math.abs(n) / 60)) + ':' + dos(Math.abs(n) % 60);
}
function dosHoras(n: number): string { return n < 10 ? '0' + n : String(n); }
function normal(v: any): string { return String(v == null ? '' : v).trim().toLowerCase(); }
function campo(obj: any, nombre: string): any {
  if (!obj) { return undefined; }
  const key = Object.keys(obj).find(k => normal(k) === normal(nombre));
  return key === undefined ? undefined : obj[key];
}
function previstas(v: any): number | null {
  if (v === undefined || v === null || String(v).trim() === '') { return null; }
  const s = String(v).replace(',', '.').trim();
  if (/^-?\d+:\d{2}$/.test(s)) {
    const p = s.replace('-', '').split(':').map(Number);
    return p[1] < 60 ? p[0] * 60 + p[1] : null;
  }
  const n = Math.abs(Number(s));
  return isFinite(n) ? Math.round(n < 24 ? n * 60 : n) : null;
}
function minutosCalculados(v: any): number | null {
  const m = /^(-?)(\d+):(\d{2})$/.exec(String(v || '').trim());
  return m && +m[3] < 60 ? (m[1] ? -1 : 1) * (+m[2] * 60 + +m[3]) : null;
}
function instante(p: any): number | null {
  const f = String(campo(p, 'FECHA') || '').substr(0, 10);
  const h = String(campo(p, 'HORA') || campo(p, 'PICADA') || '');
  const m = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(h);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(f) || !m || +m[1] > 24 || +m[2] > 59 || (+m[1] === 24 && +m[2] !== 0)) { return null; }
  const base = Date.parse(f + 'T00:00:00Z');
  return isFinite(base) ? base + (+m[1] * 60 + +m[2]) * 60000 : null;
}

export function construirDetalle(datos: DatosDetalle): any {
  const inicio = Date.parse(datos.mes + '-01T00:00:00Z');
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(datos.mes) || !isFinite(inicio)) { throw new Error('El mes seleccionado no es válido.'); }
  const d = new Date(inicio);
  const fin = Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 1);
  const DIA = 86400000;
  const problemas: { [fecha: string]: string[] } = {};
  const marcar = (t: number, motivo: string) => {
    const f = fechaDetalle(t);
    if (!problemas[f]) { problemas[f] = []; }
    if (problemas[f].indexOf(motivo) < 0) { problemas[f].push(motivo); }
  };
  const marcarRango = (a: number, b: number, motivo: string) => {
    for (let t = Math.max(inicio, Math.floor(a / DIA) * DIA); t < Math.min(fin, b); t += DIA) { marcar(t, motivo); }
  };
  const ids: { [id: string]: boolean } = {};
  const eventos: any[] = [];
  datos.picajes.forEach((p, indice) => {
    const codigo = campo(p, 'CODIGO');
    if (codigo && normal(codigo) !== normal(datos.trabajador.CODIGO)) { return; }
    const id = campo(p, 'ID');
    if (id != null && id !== '') {
      if (ids[id]) { return; }
      ids[id] = true;
    }
    const t = instante(p);
    const s = normal(campo(p, 'SENTIDO'));
    const sentido = ['ent', 'entra', 'entrada'].indexOf(s) >= 0 ? 'ent' :
      (['sal', 'sale', 'salida'].indexOf(s) >= 0 ? 'sal' : '');
    if (t === null || !sentido) {
      const fecha = Date.parse(String(campo(p, 'FECHA') || '').substr(0, 10) + 'T00:00:00Z');
      if (!isFinite(fecha)) { throw new Error('Hay fichajes sin fecha válida. Revisa los registros antes de generar el detalle.'); }
      marcar(fecha, 'Fichaje no válido');
    } else { eventos.push({ t, sentido, id: Number(id) || indice, p }); }
  });
  eventos.sort((a, b) => a.t - b.t || a.id - b.id);
  const tramos: any[] = [];
  let entrada: any = null;
  let anterior: any = null;
  eventos.forEach(e => {
    if (e.sentido === 'ent') {
      if (entrada) {
        marcarRango(entrada.t, e.t + 1, 'Entradas sin salida');
      }
      entrada = e;
    } else if (entrada) {
      if (e.t > entrada.t) { tramos.push({ inicio: entrada.t, fin: e.t, obra: campo(entrada.p, 'OBRA') || datos.trabajador.OBRA }); }
      else { marcar(e.t, 'Entrada y salida iguales'); }
      entrada = null;
    } else {
      marcarRango(anterior ? anterior.t : inicio, e.t + 1, 'Falta entrada');
    }
    anterior = e;
  });
  if (entrada) {
    const diaEntrada = Math.floor(entrada.t / DIA) * DIA;
    const vieneDelDiaAnterior = tramos.some(x =>
      x.inicio < diaEntrada && x.fin > diaEntrada && x.fin <= entrada.t);
    if (vieneDelDiaAnterior) {
      tramos.push({ inicio: entrada.t, fin: diaEntrada + DIA,
        obra: campo(entrada.p, 'OBRA') || datos.trabajador.OBRA });
    } else {
      marcarRango(entrada.t, fin, 'Falta salida');
    }
  }

  // Las parejas contiguas siguen mostrándose como fichajes; no se deduce su origen
  // manual/automático solo por coincidir con las 00:00.
  const filas: any[] = [];
  for (let t = inicio; t < fin; t += DIA) {
    const fecha = fechaDetalle(t);
    const registros = datos.resumen.filter(r => r.FECHA === fecha && r.NOMBRE !== 'SAL');
    const r = registros.find(x => x._PICADA_VIRTUAL_MEDIANOCHE ||
      String(x.PICO || '').toUpperCase() !== 'NO') || registros[0] || {};
    const calculosFecha = (datos.calculo || []).filter(c => c.FECHA === fecha);
    const calculo = calculosFecha.find(c => c._PICADA_VIRTUAL_MEDIANOCHE ||
      String(c.PICO || '').toUpperCase() !== 'NO') || calculosFecha[0];
    const turno = datos.turnos.find(x => normal(campo(x, 'NOMBRE') || campo(x, 'TURNO')) === normal(r.TURNO || datos.trabajador.TURNO));
    const trozos = tramos.filter(x => x.inicio < t + DIA && x.fin > t);
    const numeroPicadas = eventos.filter(e => fechaDetalle(e.t) === fecha).length;
    const obras = trozos.map(x => normal(x.obra));
    if (!obras.length) { obras.push(normal(r.OBRA || datos.trabajador.OBRA)); }
    const fiesta = datos.fiestas.find(f => Number(f.DIA) === new Date(t).getUTCDate() && Number(f.MES) === new Date(t).getUTCMonth() + 1 &&
      (normal(f.LUGAR) === 'todos' || obras.indexOf(normal(f.LUGAR)) >= 0));
    const ausencia = datos.ausencias.find(a => String(a.DIA || '').substr(0, 10) === fecha);
    let plan = previstas(r.HORAS_PREVISTAS);
    if (plan === null && turno) { plan = previstas(campo(turno, ['D', 'L', 'M', 'X', 'J', 'V', 'S'][new Date(t).getUTCDay()])); }
    if (fiesta || normal(r.DIA) === 'fiesta') { plan = 0; }
    // Un día futuro, una ausencia y un registro incompleto no se convierten en déficit.
    const avisos = problemas[fecha] || [];
    const fichado = trozos.reduce((s, x) => s + (Math.min(x.fin, t + DIA) - Math.max(x.inicio, t)) / 60000, 0);
    const trabajo = datos.calculo !== undefined ?
      (calculo && calculo.PICO !== 'NO' ? minutosCalculados(calculo.HORAS_TRABAJADAS) : (fichado ? null : 0)) : fichado;
    if (trabajo === null && !avisos.length) { avisos.push('Cómputo no disponible'); }
    let intervalo = 0;
    for (let i = 1; i < trozos.length; i++) { intervalo += Math.max(0, trozos[i].inicio - trozos[i - 1].fin) / 60000; }
    const textos = trozos.map(x => {
      const a = Math.max(x.inicio, t);
      const b = Math.min(x.fin, t + DIA);
      const hora = (v: number) => dos(new Date(v).getUTCHours()) + ':' + dos(new Date(v).getUTCMinutes());
      return hora(a) + '-' + (b === t + DIA ? '24:00' : hora(b)) +
        (x.inicio < t ? ' (ant.)' : '') + (x.fin > t + DIA ? ' (sig.)' : '');
    });
    if (avisos.length) { textos.push('! ' + avisos.join('; ')); }
    const estado = [fiesta ? 'Festivo' : (normal(r.DIA) === 'fiesta' ? 'Festivo' : ''), ausencia ? (ausencia.NOMBRE || 'Ausencia') : ''].filter(Boolean).join(' / ');
    filas.push({ fecha, dia: new Date(t).getUTCDate(), semana: ['D', 'L', 'M', 'X', 'J', 'V', 'S'][new Date(t).getUTCDay()],
      estado: estado || (trozos.length ? 'Con fichajes' : 'Sin fichajes'), tramos: textos.length ? textos : ['--'],
      trabajo: avisos.length ? null : trabajo, parcial: trabajo || 0, fichado, intervalo: avisos.length ? null : intervalo,
      previstas: plan, saldo: !avisos.length && trozos.length && plan !== null ?
      (datos.calculo !== undefined ? (calculo && calculo.PICO !== 'NO' ? minutosCalculados(calculo.HORAS_EXTRAS) : null) : (!ausencia ? fichado - plan : null)) : null,
      incidencias: avisos.length > 0, festivo: !!fiesta || normal(r.DIA) === 'fiesta', guardia: normal(campo(turno, 'MODO')) === 'guardia',
      calculoDia: calculo || null, ausencia: ausencia || null, fiestaNombre: fiesta ? fiesta.NOMBRE : '', numeroPicadas });
  }
  const incompleto = filas.some(f => f.incidencias);
  const guardia = filas.some(f => f.guardia);
  const saldoFilas = filas.filter(f => f.saldo !== null);
  const total = filas.reduce((s, f) => s + (f.trabajo === null ? f.parcial : f.trabajo), 0);
  let totalPrevistas = saldoFilas.reduce((s, f) => s + f.previstas, 0);
  let saldo = saldoFilas.reduce((s, f) => s + f.saldo, 0);
  let saldoValido = !incompleto && saldoFilas.length > 0 &&
    !filas.some(f => f.fichado > 0 && (f.previstas === null || f.trabajo === null));
  if (guardia) {
    const contrato = Number(String(datos.trabajador.HORAS_CONTRATO || '').replace(',', '.'));
    saldoValido = !incompleto && contrato > 0;
    totalPrevistas = Math.round(((fin - inicio) / DIA) * contrato / 7 * 60);
    saldo = total - totalPrevistas;
    filas.forEach(f => f.saldo = null);
  }
  return { filas, total, totalPrevistas, saldo, saldoValido, incompleto, guardia,
    totalFestivo: filas.filter(f => f.festivo).reduce((s, f) => s + f.parcial, 0),
    diasSaldo: saldoFilas.length };
}

export function dibujarDetalle(doc: any, datos: DatosDetalle, soloAnexo: boolean = false): any {
  const modelo = construirDetalle(datos);
  const mesNombre = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'][Number(datos.mes.substr(5)) - 1];
  const razon = datos.empresa.NOMBRE || datos.empresa.RAZSOCIAL || '';
  const cif = datos.empresa.CIF || '';
  const direccion = datos.empresa.DIRECCION || '';
  const escribir = (s: any, x: number, y: number, tam: number = 8, estilo: string = 'normal', align?: string) => {
    if (String(s).indexOf('Color:') === 0) {
      s = 'Color: verde oscuro = trabajado - gris claro = sin trabajar. B/N: franja oscura = trabajado - franja clara = sin trabajar.';
    }
    doc.setFont('helvetica', estilo); doc.setFontSize(tam); doc.text(String(s == null ? '' : s), x, y, align ? { align } : undefined);
  };
  const minutosCampo = (v: any): number | null => minutosCalculados(v);
  const sumaCampo = (nombre: string): number => modelo.filas.reduce((s, f) => {
    const c = f.calculoDia;
    const valor = c && c.PICO !== 'NO' ? minutosCampo(c[nombre]) : null;
    return s + (valor == null ? 0 : valor);
  }, 0);
  const fuente = (f: any, nombre: string, alternativo: string = ''): string => {
    const c = f.calculoDia;
    if (c && c.PICO !== 'NO' && c[nombre] != null && c[nombre] !== '') { return String(c[nombre]); }
    return alternativo;
  };

  // Cabecera y textos legales: misma posición y misma distribución que el PDF antiguo.
  const marcas: { [fecha: string]: number } = {};
  let siguienteMarca = 0;
  modelo.filas.forEach(f => {
    if (f.numeroPicadas >= 6) { marcas[f.fecha] = ++siguienteMarca; }
  });

  if (!soloAnexo) {
  doc.setProperties({ title: 'Registro Diario de Horas - ' + datos.mes, subject: 'Registro mensual de jornada', creator: 'Control Horario' });
  doc.setTextColor(0, 0, 0);
  escribir('Registro Diario de Horas', 70, 9, 15, 'bold');
  escribir('En cumplimiento de lo establecido en art. 10.dos del RD-ley 8/2019, que modifica el art. 34 del ET, añadiendo el apart. 9', 40, 13, 7);
  doc.rect(5, 15, 200, 6);
  escribir('EMPRESA', 40, 20, 11); escribir('TRABAJADOR', 130, 20, 11);
  escribir('Nombre:', 8, 27, 9); escribir('Nombre:', 110, 27, 9);
  escribir('Cif:', 16, 33, 9); escribir('Nif:', 118, 33, 9);
  escribir(razon, 25, 27, 9); escribir(cif, 25, 33, 9);
  escribir(datos.trabajador.NOMBRE || '', 125, 27, 9);
  escribir(datos.trabajador.CODIGO || '', 125, 33, 9);
  doc.rect(5, 41, 200, 6);
  escribir('Periodo:', 8, 45, 9); escribir(datos.mes + '-01 al ' + datos.mes + '-' + dos(modelo.filas.length), 30, 45, 9);

  const xs = [5, 30, 55, 80, 105, 130, 155, 180, 205];
  const cabeceras = ['Fechas', 'Entrada', 'Salida', 'Almorzando', 'Descanso', 'Sin trabajar', 'Ordinarias', 'Horas Extras'];
  cabeceras.forEach((titulo, i) => { doc.rect(xs[i], 50, 25, 7); escribir(titulo, xs[i] + 2, 54, 8); });

  const entradaSalida = (tramo: string): string[] => {
    const limpio = String(tramo || '').replace(/ \(ant\.\)| \(sig\.\)/g, '');
    const p = limpio.split('-'); return [p[0] || '', p[1] || ''];
  };
  const horasTramos = (f: any): string[][] => (f.tramos || [])
    .filter((v: string) => v && v !== '--' && v.charAt(0) !== '!')
    .map((v: string) => entradaSalida(v));
  const escribirHorasCuatro = (f: any, y: number, tramos: string[][]) => {
    // Desde cuatro picadas: se conserva la entrada y salida principales en negrita.
    // La segunda hora de cada cuadrado queda pequeña y gris, sin cambiar columnas.
    const primero = tramos[0] || ['', ''];
    const ultimo = tramos[tramos.length - 1] || primero;
    const secundariosEntrada = tramos.slice(0, -1).map(t => t[1]).filter(v => !!v);
    const secundariosSalida = tramos.slice(1).map(t => t[0]).filter(v => !!v);
    doc.setTextColor(0, 0, 0);
    escribir(primero[0], 50, y + 4, 9, 'bold', 'right');
    doc.setTextColor(150, 150, 150);
    escribir(secundariosEntrada.join(' · '), 54, y + 4, secundariosEntrada.length > 3 ? 3.6 : 4.3, 'normal', 'right');
    escribir(secundariosSalida.join(' · '), 56, y + 4, secundariosSalida.length > 3 ? 3.6 : 4.3, 'normal');
    doc.setTextColor(0, 0, 0);
    escribir(ultimo[1], 79, y + 4, 9, 'bold', 'right');
  };

  doc.setDrawColor(0, 0, 0);
  let y = 57;
  let fiestasY = 244;
  const diasGrandes = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
  modelo.filas.forEach(f => {
    const tramosValidos = (f.tramos || []).filter((v: string) => v && v !== '--' && v.charAt(0) !== '!');
    const vacio = tramosValidos.length === 0;
    doc.setFontSize(8.5); doc.setTextColor(0, 0, 0);
    if (vacio) {
      // Como en el PDF antiguo: una sola fila gris para días sin fichajes.
      // No se vuelven a dibujar encima los ocho bordes de las columnas.
      doc.setFillColor(240, 240, 240); doc.rect(5, y, 200, 5, 'FD');
    } else {
      for (let i = 0; i < 8; i++) { doc.rect(xs[i], y, 25, 5.5); }
    }
    escribir(f.semana + ' ' + dos(f.dia) + '/' + datos.mes.substr(5) + '/' + datos.mes.substr(0, 4), 25, y + 3.8, 8.5, 'normal', 'right');
    if (vacio) {
      const fecha = new Date(f.fecha + 'T12:00:00Z');
      const textoDia = f.ausencia ? f.ausencia.NOMBRE : (f.festivo ? (f.fiestaNombre || 'Festivo') : diasGrandes[fecha.getUTCDay()]);
      escribir(f.incidencias ? 'REVISAR: ' + (f.estado || 'Incidencia') : textoDia, 35, y + 3.8, 8.5, f.incidencias ? 'bold' : 'normal');
    } else {
      const tramos = horasTramos(f);
      if (f.numeroPicadas >= 4 && tramos.length >= 2) {
        escribirHorasCuatro(f, y, tramos);
      } else {
        // Con dos picadas (y también con seis o más) se conserva Entrada/Salida.
        const primero = tramos[0] || ['', ''];
        const ultimo = tramos[tramos.length - 1] || primero;
        escribir(primero[0], 50, y + 4, 8.5, 'bold', 'right');
        escribir(ultimo[1], 75, y + 4, 8.5, 'bold', 'right');
      }
      if (f.numeroPicadas >= 6) {
        escribir('*' + marcas[f.fecha], 7, y + 3.8, 4.2, 'bold');
      }
      const almuerzo = fuente(f, 'HORAS_ALMORZANDO', '');
      const descanso = fuente(f, 'HORAS_PARADAS', f.intervalo ? minutosTexto(f.intervalo) : '');
      const sinTrabajar = fuente(f, 'HORAS_SIN_TRABAJAR', '');
      const ordinarias = fuente(f, 'HORAS_TRABAJADAS', f.trabajo == null ? '' : minutosTexto(f.trabajo));
      const extras = fuente(f, 'HORAS_EXTRAS', '');
      [almuerzo, descanso, sinTrabajar, ordinarias, extras].forEach((valor, i) => {
        escribir(valor, xs[i + 3] + 20, y + 4, 8.5, i >= 3 ? 'bold' : 'normal', 'right');
      });
      if (f.festivo && f.calculoDia && f.trabajo > 0) { escribir(f.estado, 10, fiestasY, 8.5); fiestasY += 5; }
    }
    y += 5.5;
  });

  const ordinariasTotal = sumaCampo('HORAS_TRABAJADAS') || modelo.total;
  const extrasTotal = sumaCampo('HORAS_EXTRAS');
  doc.rect(155, y, 25, 5.5); doc.rect(180, y, 25, 5.5);
  escribir('Fiestas de ' + mesNombre + ' trabajadas', 10, 238, 8.5);
  doc.rect(80, 240, 50, 28); escribir('Firma o sello de la empresa', 90, 238, 8.5);
  doc.rect(150, 240, 52, 28); escribir('Firma del trabajador', 160, 238, 8.5);
  escribir(minutosTexto(ordinariasTotal), 175, y + 4, 8.5, 'bold', 'right');
  escribir(modelo.saldoValido ? minutosTexto(extrasTotal || modelo.saldo, true) : '--', 200, y + 4, 8.5, 'bold', 'right');

  // Texto RGPD conservado del informe anterior.
  const rgpd = 'RGPD y Ley Orgánica 3/2018 de Protección de Datos: los datos de carácter personal que nos proporciona serán tratados por ' + razon + ' como\n' +
    'Responsable de Tratamiento. La finalidad de la recogida y tratamiento de los datos es la adecuada gestión interna de las relaciones entre la empresa y sus empleados y que no\n' +
    'serán cedidos, sin perjuicio de su tratamiento por aquellas personas o entidades con las que ' + razon + ' en el ejercicio de sus facultades legítimas mantenga\n' +
    'relaciones para el adecuado cumplimiento de sus obligaciones legales derivadas de la Normativa Laboral, de Seguridad Social, y Tributaria. ' + razon + '\n' +
    'informa de que el trabajador puede ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad en ' + direccion + '\n' +
    'Si considera que el tratamiento no se ajusta a la normativa vigente, podrá presentar una reclamación ante la autoridad de control en www.aepd. Mayor información en nuestras dependencias.\n';
  escribir(rgpd, 105, 275, 6, 'normal', 'center');
  escribir('Informe realizado por la aplicación Control Horario ver.101  -- nº 1--', 105, 289, 6, 'normal', 'center');

  // Segunda cara: anexo informativo. La primera página mantiene el registro
  // oficial y esta cuadrícula explica de dónde sale cada resultado diario.
  }
  doc.addPage();
  doc.setTextColor(0, 0, 0);
  escribir('Detalle informativo de picadas y cálculo', 105, 10, 12, 'bold', 'center');
  escribir('Anexo del registro mensual. La primera página es la hoja destinada a la firma.', 105, 15, 7, 'normal', 'center');
  escribir('E = entrada · S = salida · los tramos se forman emparejando cada E con la S siguiente.', 8, 21, 6.5);

  escribir('Color: verde = trabajado · rojo = sin trabajar. B/N: franja lisa = trabajado · franja rayada = sin trabajar.', 8, 24, 5.8);

  const picadasPorFecha: { [fecha: string]: string[] } = {};
  const idsPicadas: { [id: string]: boolean } = {};
  (datos.picajes || []).forEach((p, indice) => {
    const fecha = String(campo(p, 'FECHA') || '').substr(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha)) { return; }
    const codigo = campo(p, 'CODIGO');
    if (codigo && normal(codigo) !== normal(datos.trabajador.CODIGO)) { return; }
    const id = campo(p, 'ID');
    if (id != null && id !== '') {
      if (idsPicadas[id]) { return; }
      idsPicadas[id] = true;
    }
    const t = instante(p);
    if (t === null) { return; }
    const sentido = normal(campo(p, 'SENTIDO'));
    const letra = ['ent', 'entra', 'entrada'].indexOf(sentido) >= 0 ? 'E' :
      (['sal', 'sale', 'salida'].indexOf(sentido) >= 0 ? 'S' : '');
    if (!letra) { return; }
    if (!picadasPorFecha[fecha]) { picadasPorFecha[fecha] = []; }
    const hora = dos(new Date(t).getUTCHours()) + ':' + dos(new Date(t).getUTCMinutes());
    picadasPorFecha[fecha].push(hora + ' ' + letra);
  });
  Object.keys(picadasPorFecha).forEach(fecha => picadasPorFecha[fecha].sort());

  const valorAnexo = (f: any, nombre: string, vacio: string = '--'): string => {
    const c = f.calculoDia;
    return c && c.PICO !== 'NO' && c[nombre] != null && c[nombre] !== '' ? String(c[nombre]) : vacio;
  };
  const linea = (docTexto: string, x: number, yLinea: number, anchoLinea: number, tam: number, negrita: boolean = false): number => {
    // Aumenta un poco los textos de cada cuadro sin agrandar la cuadrÃ­cula.
    const tamano = tam <= 5.9 ? 7.0 : tam;
    const campo = /^(Picadas|Tramos|Previsto|Sin trabajar|Ordinarias|Extras):\s*(.*)$/.exec(docTexto);
    if (campo) {
      const etiqueta = campo[1] + ':';
      const valor = campo[2] || '';
      doc.setFont('helvetica', 'bold'); doc.setFontSize(tamano);
      const anchoEtiqueta = doc.getTextWidth(etiqueta);
      const anchoValor = Math.max(8, anchoLinea - anchoEtiqueta - 1);
      const valores = doc.splitTextToSize(valor, anchoValor);
      doc.setTextColor(85, 85, 85);
      doc.text(etiqueta, x, yLinea);
      doc.setTextColor(0, 0, 0);
      doc.setFont('helvetica', negrita ? 'bold' : 'normal');
      doc.text(valores[0] || '', x + anchoEtiqueta + 1, yLinea);
      for (let i = 1; i < valores.length; i++) {
        doc.text(valores[i], x, yLinea + i * 2.3);
      }
      return Math.max(1, valores.length) * 2.3;
    }
    doc.setFont('helvetica', negrita ? 'bold' : 'normal'); doc.setFontSize(tamano);
    const lineas = doc.splitTextToSize(docTexto, anchoLinea);
    lineas.forEach((texto: string, indice: number) => doc.text(texto, x, yLinea + indice * 2.3));
    return lineas.length * 2.3;
  };
  const dibujarTiempo24 = (f: any, x: number, yCaja: number) => {
    const bx = x + 2, by = yCaja + 8.1, bw = gw - 4, bh = 2.8;
    // Todo el día empieza en rojo; los tramos fichados se superponen en verde.
    doc.setFillColor(238, 238, 238); doc.rect(bx, by, bw, bh, 'F');
    const minutosHora = (hora: string): number => {
      const p = String(hora || '').split(':').map(Number);
      return (p[0] || 0) * 60 + (p[1] || 0);
    };
    (f.tramos || []).forEach((tramo: string) => {
      const m = /^(\d{2}:\d{2})-(\d{2}:\d{2})/.exec(String(tramo || ''));
      if (!m) { return; }
      const inicio = Math.max(0, Math.min(1440, minutosHora(m[1])));
      const fin = Math.max(inicio, Math.min(1440, minutosHora(m[2])));
      if (fin > inicio) {
        doc.setFillColor(48, 145, 68);
        doc.rect(bx + (inicio / 1440) * bw, by, ((fin - inicio) / 1440) * bw, bh, 'F');
      }
    });
    doc.setDrawColor(80, 80, 80); doc.setLineWidth(0.15); doc.rect(bx, by, bw, bh);
    (picadasPorFecha[f.fecha] || []).forEach((picada: string) => {
      const m = /^(\d{2}:\d{2})\s+([ES])$/.exec(picada);
      if (!m) { return; }
      const px = bx + (minutosHora(m[1]) / 1440) * bw;
      doc.setDrawColor(m[2] === 'E' ? 0 : 30, m[2] === 'E' ? 0 : 70, m[2] === 'E' ? 0 : 160);
      doc.setLineWidth(0.45); doc.line(px, by - 1.1, px, by + bh + 1.1);
    });
    doc.setTextColor(70, 70, 70);
    escribir('00:00', bx, yCaja + 7.2, 4.8);
    escribir('24:00', bx + bw, yCaja + 7.2, 4.8, 'normal', 'right');
  };
  const gx = 7, gy = 26, gw = 49, gh = 31;
  modelo.filas.forEach((f, indice) => {
    const columna = indice % 4;
    const fila = Math.floor(indice / 4);
    const x = gx + columna * gw;
    const yCaja = gy + fila * gh;
    doc.setDrawColor(80, 80, 80); doc.setLineWidth(0.25); doc.rect(x, yCaja, gw, gh);
    doc.setFillColor(245, 245, 245); doc.rect(x, yCaja, gw, 5, 'F');
    doc.setTextColor(0, 0, 0);
    const marca = marcas[f.fecha] ? '*' + marcas[f.fecha] + ' ' : '';
    const fechaCaja = new Date(f.fecha + 'T12:00:00Z');
    const diasGrandesCaja = ['Domingo', 'Lunes', 'Martes', 'Mi\u00e9rcoles', 'Jueves', 'Viernes', 'S\u00e1bado'];
    const nombreDiaCaja = f.ausencia ? (f.ausencia.NOMBRE || 'Vacaciones') :
      (f.festivo ? (f.fiestaNombre || 'Fiesta') : diasGrandesCaja[fechaCaja.getUTCDay()]);
    escribir(marca + nombreDiaCaja + ' ' + dos(f.dia) + '/' + datos.mes.substr(5), x + 2, yCaja + 3.6, 7.4, 'bold');
    dibujarTiempo24(f, x, yCaja);
    doc.setTextColor(0, 0, 0);
    const picadas = picadasPorFecha[f.fecha] || [];
    const p = picadas.length ? picadas.join(' · ') : '--';
    const tramos = (f.tramos || []).filter((v: string) => v && v !== '--' && v.charAt(0) !== '!').join(' | ') || '--';
    let yy = yCaja + 14.3;
    yy += linea('Picadas: ' + p, x + 2, yy, gw - 4, 5.9, false);
    yy += linea('Tramos: ' + tramos, x + 2, yy, gw - 4, 5.9, false);
    yy += linea('Previsto: ' + (f.previstas == null ? '--' : minutosTexto(f.previstas)), x + 2, yy, gw - 4, 5.9, false);
    yy += linea('Sin trabajar: ' + valorAnexo(f, 'HORAS_SIN_TRABAJAR', f.incidencias ? 'REVISAR' : '00:00') +
      ' · Almuerzo: ' + valorAnexo(f, 'HORAS_ALMORZANDO', '00:00'), x + 2, yy, gw - 4, 5.5, false);
    yy += linea('Ordinarias: ' + valorAnexo(f, 'HORAS_TRABAJADAS', f.trabajo == null ? '--' : minutosTexto(f.trabajo)), x + 2, yy, gw - 4, 5.9, true);
    linea('Extras: ' + valorAnexo(f, 'HORAS_EXTRAS', '--') + ' · Descanso: ' + valorAnexo(f, 'HORAS_PARADAS', '00:00'), x + 2, yy, gw - 4, 5.5, true);
  });
  linea('Lectura del cálculo: las picadas E-S forman los tramos; las pausas se separan como descanso. “Sin trabajar” es el tiempo no computable según el tipo de pausa. “Ordinarias” aplica el turno, almuerzo y pausas configuradas. “Extras” compara las ordinarias con las previstas y aplica cortesía/ajuste, igual que el informe habitual.', 8, 278, 194, 5.8, false);
  return modelo;
}



// WEBPACK FOOTER //
// ./src/pages/list/pdf-detalle.ts